import { canAccessFeature, defaultPathForRole, productLabel } from "../../js/auth/packageAccess";
import { useAuth } from "../../js/hooks/useAuth";

/** Blocks routes when the current package does not include a desk feature. */
export default function RequireFeature({ feature, children }) {
  const { session } = useAuth();

  if (!session?.role || session.role === "admin") return children;
  if (canAccessFeature(session, feature)) return children;

  return (
    <div className="card page-header" style={{ margin: "1.5rem auto", maxWidth: "42rem" }}>
      <h1>Not included in your plan</h1>
      <p className="page-lead">
        {productLabel(session)} does not include this tool. Upgrade or contact your office admin if
        you believe you should have access.
      </p>
      <p>
        <a className="primary-btn" href={defaultPathForRole(session.role)}>
          Back to your desk
        </a>
      </p>
    </div>
  );
}
